<template>
  <a-spin :spinning="confirmLoading">
    <a-tabs defaultActiveKey="1" type="card" @tabClick="onTabClick">
      <a-tab-pane tab="当前版本" key="1">
        <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24" v-if="isEdit">
            <a-form-item label="项目名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag type="list" v-decorator="['projId', validatorRules.projId]" :trigger-change="true" dict="proj_project,name,id" :async="true" disabled/>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-else> <!--新增情况,过滤掉已经提交的-->
            <a-form-item label="项目名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag type="list" v-decorator="['projId', validatorRules.projId]" :trigger-change="true" :dictOptions="projectOptions" placeholder="请选择项目"/>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="查勘情况" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-tooltip placement="topLeft" overlayClassName="draw_atooltip" title="请输入企业环境情况（包括但不限于自然环境、地势环境、周边环境）；生产概况调查（包括但不限于生产工艺、工艺过程、原材料、半成品、成品、建筑物结构、使用性质、建筑物布局、机器设备、电气线路等）；消防概况调查（公共消防、自备消防、消防水源等）；防汛防雷防火防爆炸概况；安全管理水平；以往损失记录">
                <a-textarea v-decorator="['surveyResult',validatorRules.surveyResult]" :auto-size="{ minRows: 5, maxRows: 5 }"
                  placeholder="请输入企业环境情况（包括但不限于自然环境、地势环境、周边环境）；生产概况调查（包括但不限于生产工艺、工艺过程、原材料、半成品、成品、建筑物结构、使用性质、建筑物布局、机器设备、电气线路等）；消防概况调查（公共消防、自备消防、消防水源等）；防汛防雷防火防爆炸概况；安全管理水平；以往损失记录"/>
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="风险点1" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea rows="3" v-decorator="['riskPoint1',validatorRules.riskPoint1]"
                placeholder="请输入查勘的风险点描述"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="解决方案1" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea rows="3" v-decorator="['solution1',validatorRules.solution]"
                placeholder="请输入对应风险点的保险解决方案"/>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="riskPointShow2">
            <a-form-item label="风险点2" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea rows="3" v-decorator="['riskPoint2',validatorRules.riskPoint2]"
                placeholder="请输入查勘的风险点描述"/>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="riskPointShow2">
            <a-form-item label="解决方案2" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea rows="3" v-decorator="['solution2',validatorRules.solution]"
              placeholder="请输入对应风险点的保险解决方案"/>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="riskPointShow3">
            <a-form-item label="风险点3" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea rows="3" v-decorator="['riskPoint3',validatorRules.riskPoint3]"
              placeholder="请输入查勘的风险点描述"/>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="riskPointShow3">
            <a-form-item label="解决方案3" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea rows="3" v-decorator="['solution3',validatorRules.solution]"
              placeholder="请输入对应风险点的保险解决方案"/>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="riskPointShow4">
            <a-form-item label="风险点4" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea rows="3" v-decorator="['riskPoint4',validatorRules.riskPoint4]"
              placeholder="请输入查勘的风险点描述"/>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="riskPointShow4">
            <a-form-item label="解决方案4" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea rows="3" v-decorator="['solution4',validatorRules.solution]"
              placeholder="请输入对应风险点的保险解决方案"/>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="riskPointShow5">
            <a-form-item label="风险点5" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea rows="3" v-decorator="['riskPoint5',validatorRules.riskPoint5]"
              placeholder="请输入查勘的风险点描述"/>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="riskPointShow5">
            <a-form-item label="解决方案5" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea rows="3" v-decorator="['solution5',validatorRules.solution]"
              placeholder="请输入对应风险点的保险解决方案"/>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="riskPointShow6">
            <a-form-item label="风险点6" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea rows="3" v-decorator="['riskPoint6',validatorRules.riskPoint6]"
              placeholder="请输入查勘的风险点描述"/>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="riskPointShow6">
            <a-form-item label="解决方案6" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea rows="3" v-decorator="['solution6',validatorRules.solution]"
              placeholder="请输入对应风险点的保险解决方案"/>
            </a-form-item>
          </a-col>

          <a-col :span="24" v-if="addButtonShow">
            <a-button @click="handleAddRiskPoint" style="margin-left: 155px; margin-bottom: 20px;">新增风险点</a-button>
            <a-button @click="handleDelRiskPoint" style="margin-left: 60px; margin-bottom: 20px;">删除风险点</a-button>
          </a-col>
          
          <a-col :span="24">
            <a-form-item label="风险管理与保险解决方案附件" :labelCol="{span:7,offset:2}" :wrapperCol="{ span: 12 }">
              <j-upload v-decorator="['file',validatorRules.file]" :disabled="disabled" :trigger-change="true"  bizPath="risk-manage" @change="handleFileChange"/>
            </a-form-item>
          </a-col>

          <a-col :span="24" v-if="model != null && model.auditRemark"> <!--status='04',只能显示撤销状态的，退回状态的无法显示-->
            <a-form-item label="审核备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea rows="3" v-decorator="['auditRemark',{}]" disabled/>
            </a-form-item>
          </a-col>

          <a-col :span="24" v-if="!formDisabled"> 
            <a-form-item label="模板下载" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a style="margin-right:30px;" :href="`${path}风险管理方案.docx`" download="风险管理方案.docx">风险管理方案</a>
              <a style="margin-right:30px;" :href="`${path}保险解决方案.docx`" download="保险解决方案.docx">保险解决方案</a>
              <a style="margin-right:30px;" :href="`${path}风险管理和保险解决方案.docx`" download="风险管理和保险解决方案.docx">风险管理和保险解决方案</a>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
      </a-tab-pane>
      <a-tab-pane v-for="version in tabs" :tab="version" :key="version">
        <j-form-container :disabled="formDisabled">
          <a-form slot="detail">
            <a-row>
              <a-col :span="24">
                <a-form-item label="项目名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <!-- 历史版本 tab 为只读回显，tabModel.name 存的是项目名称文本(非 id)，
                       用 proj_project,name,id 字典匹配不上(该字典 value 是 id)，原先靠 a-select
                       找不到 option 时回退显示原值才正常，代价是每次都全量拉 1469 条项目。
                       直接用只读输入框显示该文本，效果一致且不再请求字典。 -->
                  <a-input v-model="tabModel.name" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="查勘情况" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-tooltip placement="topLeft" overlayClassName="draw_atooltip" title="请输入企业环境情况（包括但不限于自然环境、地势环境、周边环境）；生产概况调查（包括但不限于生产工艺、工艺过程、原材料、半成品、成品、建筑物结构、使用性质、建筑物布局、机器设备、电气线路等）；消防概况调查（公共消防、自备消防、消防水源等）；防汛防雷防火防爆炸概况；安全管理水平；以往损失记录">
                    <a-textarea v-model="tabModel.surveyResult" :auto-size="{ minRows: 5, maxRows: 5 }"
                                placeholder="请输入企业环境情况（包括但不限于自然环境、地势环境、周边环境）；生产概况调查（包括但不限于生产工艺、工艺过程、原材料、半成品、成品、建筑物结构、使用性质、建筑物布局、机器设备、电气线路等）；消防概况调查（公共消防、自备消防、消防水源等）；防汛防雷防火防爆炸概况；安全管理水平；以往损失记录"  disabled/>
                  </a-tooltip>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="风险点1" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-textarea rows="3" v-model="tabModel.riskPoint1"
                              placeholder="请输入查勘的风险点描述" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="解决方案1" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-textarea rows="3" v-model="tabModel.solution1"
                              placeholder="请输入对应风险点的保险解决方案" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24" v-if="riskPointShow2">
                <a-form-item label="风险点2" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-textarea rows="3" v-model="tabModel.riskPoint2"
                              placeholder="请输入查勘的风险点描述" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24" v-if="riskPointShow2">
                <a-form-item label="解决方案2" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-textarea rows="3" v-model="tabModel.solution2"
                              placeholder="请输入对应风险点的保险解决方案" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24" v-if="riskPointShow3">
                <a-form-item label="风险点3" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-textarea rows="3" v-model="tabModel.riskPoint3"
                              placeholder="请输入查勘的风险点描述" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24" v-if="riskPointShow3">
                <a-form-item label="解决方案3" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-textarea rows="3" v-model="tabModel.solution3"
                              placeholder="请输入对应风险点的保险解决方案" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24" v-if="riskPointShow4">
                <a-form-item label="风险点4" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-textarea rows="3" v-model="tabModel.riskPoint4"
                              placeholder="请输入查勘的风险点描述" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24" v-if="riskPointShow4">
                <a-form-item label="解决方案4" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-textarea rows="3" v-model="tabModel.solution4"
                              placeholder="请输入对应风险点的保险解决方案" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24" v-if="riskPointShow5">
                <a-form-item label="风险点5" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-textarea rows="3" v-model="tabModel.riskPoint5"
                              placeholder="请输入查勘的风险点描述" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24" v-if="riskPointShow5">
                <a-form-item label="解决方案5" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-textarea rows="3" v-model="tabModel.solution5"
                              placeholder="请输入对应风险点的保险解决方案" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24" v-if="riskPointShow6">
                <a-form-item label="风险点6" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-textarea rows="3" v-model="tabModel.riskPoint6"
                              placeholder="请输入查勘的风险点描述" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24" v-if="riskPointShow6">
                <a-form-item label="解决方案6" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-textarea rows="3" v-model="tabModel.solution6"
                              placeholder="请输入对应风险点的保险解决方案" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="风险管理与保险解决方案附件" :labelCol="{span:7,offset:2}" :wrapperCol="{ span: 12 }">
                  <j-upload v-model="tabModel.file" bizPath="risk-manage" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24" v-if="model != null && model.auditRemark"> <!--status='04',只能显示撤销状态的，退回状态的无法显示-->
                <a-form-item label="审核备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-textarea rows="3" v-model="tabModel.auditRemark" disabled/>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </j-form-container>
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>

  import { httpAction, getAction, postAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JSearchSelectTag from "@/components/dict/JSearchSelectTag"
  import JEditor from '@/components/jeecg/JEditor'
  import JUpload from '@/components/jeecg/JUpload'
  import ProjectStatus from '../../ProjectStatus'
  import ProjectConst from '@views/project/ProjectConst'

  export default {
    name: 'RiskManagementForm',
    components: {
      JUpload,
      JFormContainer,
      JDate,
      JSearchSelectTag,
      JDictSelectTag,
      JEditor,
    },
    props: {
      //表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        projectOptions: [],
        tabs: [],
        tabModel: {},
        description: '风险管理页面',
        form: this.$form.createForm(this),
        path: ProjectConst.OSS_ADR_TEMPLATE,
        isEdit: false, // 是否编辑
        isAdd: false, // 是否新增
        riskPointNumber:1, // 风险点数量
        projectStatus:{},
        model: {
        },
        fileList:[],
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          projId: {
            rules: [
              { required: true, message: '请选择项目!'},
            ]
          },
          /*customerName: {
            rules: [
              { required: true, message: '请选择客户!'},
              { whitespace: true, message:'客户不能为空'}
            ]
          },*/

          surveyResult: {
            rules: [
              { required: true, message: '查勘情况不能为空!'},
              { max: 2000, message: '查勘情况长度不能超过2000个字符!'},
              { whitespace: true, message:'不能为空格'}
            ]
          },
          riskPoint1: {
            rules: [
              { required: true, message: '风险点不能为空!'},
              { max: 255, message: '风险点长度不能超过255个字符!'},
              { whitespace: true, message:'不能为空格'}
            ]
          },
          riskPoint2: {
            rules: [
              { required: true, message: '风险点不能为空!'},
              { max: 255, message: '风险点长度不能超过255个字符!'},
              { whitespace: true, message:'不能为空格'}
            ]
          },
          riskPoint3: {
            rules: [
              { required: true, message: '风险点不能为空!'},
              { max: 255, message: '风险点长度不能超过255个字符!'},
              { whitespace: true, message:'不能为空格'}
            ]
          },
          riskPoint4: {
            rules: [
              { required: true, message: '风险点不能为空!'},
              { max: 255, message: '风险点长度不能超过255个字符!'},
              { whitespace: true, message:'不能为空格'}
            ]
          },
          riskPoint5: {
            rules: [
              { required: true, message: '风险点不能为空!'},
              { max: 255, message: '风险点长度不能超过255个字符!'},
              { whitespace: true, message:'不能为空格'}
            ]
          },
          riskPoint6: {
            rules: [
              { required: true, message: '风险点不能为空!'},
              { max: 255, message: '风险点长度不能超过255个字符!'},
              { whitespace: true, message:'不能为空格'}
            ]
          },
          solution:{
            rules: [
              { required: true, message: '解决方案不能为空!'},
              { max: 255, message: '解决方案长度不能超过255个字符!'},
              { whitespace: true, message:'不能为空格'}
            ]
          },
          file: {
            rules: [
              { required: true, message: '附件不能为空!'},
            ]
          },
        },
        url: {
          add: "/project/riskmanage/add",
          edit: "/project/riskmanage/edit",
          queryById: "/project/riskmanage/queryById",
          updateFilePath:"/project/riskmanage/updateFilePathImmediate",
          hisData:"/project/riskmanage/hisData",
        }
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      riskPointShow2() {
          //let value = this.form.getFieldValue('riskPoint2')
          if ((this.riskPointNumber >=2)) {
            return true
          } else {
            return false
          }
      },
      riskPointShow3() {
        //let value = this.form.getFieldValue('riskPoint3')
        if ((this.riskPointNumber >=3)) {
          return true
        } else {
          return false
        }
      },
      riskPointShow4() {
        //let value = this.form.getFieldValue('riskPoint4')
        if ((this.riskPointNumber >=4)) {
          return true
        } else {
          return false
        }
      },
      riskPointShow5() {
        //let value = this.form.getFieldValue('riskPoint5')
        if ((this.riskPointNumber >=5)) {
          return true
        } else {
          return false
        }
      },
      riskPointShow6() {
        //let value = this.form.getFieldValue('riskPoint6')
        if ((this.riskPointNumber >=6)) {
          return true
        } else {
          return false
        }
      },
      addButtonShow(){
        if(this.disabled){ // 详情
          return false
        } else {// 编辑或新增
          return true
        }
      },      

    },
    created () {
      this.riskPointNumber = 1;  // 初始值1
      this.projectStatus = ProjectStatus
      this.loadProjectOptions()
    },
    methods: {
      onTabClick(key) {
        if(key == 1) {return;}
        let url = this.url.hisData;
        let tempModel = this.tabModel;
        let param = {version: key,projId: this.tabModel.projId};
        postAction(url,param).then((res)=>{
          if(res.success){
            if(res.result){
              Object.keys(res.result).forEach(key => {
                tempModel[key] = res.result[key]
              })
            } else {
              callback('未找到该项目');
            }
          }else{
            callback(res.message);
          }
        })
      },
      // 项目候选由后端按当前用户的项目权限过滤（原先用 sys_org_code 过滤，该列从未被写入过）
      loadProjectOptions() {
        getAction("/project/baseInfo/optionList", {status: this.projectStatus.IDEA_WAIT + "," + this.projectStatus.RENEWAL}).then(res => {
          if (res.success) {
            this.projectOptions = res.result || []
          } else {
            this.$message.warning(res.message)
          }
        })
      },
      add () {
        this.isAdd = true
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.calcRiskPointNumber()
        //编辑禁止修改项目名称
        if(this.model.id){
          this.isEdit = true;
        }else{ // 新增可以修改
          this.isEdit = false;
        }
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.form.setFieldsValue(pick(this.model,'projId','surveyResult', 'riskPoint1','solution1','riskPoint2','solution2',
              'riskPoint3','solution3','riskPoint4','solution4','riskPoint5','solution5','riskPoint6','solution6',
              'file', 'auditRemark'))
          })
        })
        let vs = this.model.versions
        if(vs) {
          this.tabModel = Object.assign({}, record);
          this.tabs = vs.split(',');
        } else {
          this.tabs = []
        }
      },

      // 计算风险点数
      calcRiskPointNumber(){
        if(this.model.riskPoint6){
          this.riskPointNumber = 6
        } else if(this.model.riskPoint5){
          this.riskPointNumber = 5
        } else if(this.model.riskPoint4){
          this.riskPointNumber = 4
        } else if(this.model.riskPoint3){
          this.riskPointNumber = 3
        } else if(this.model.riskPoint2){
          this.riskPointNumber = 2
        } else {
          this.riskPointNumber = 1
        }
      },

      // 新增风险点
      handleAddRiskPoint(){
        if(this.riskPointNumber < 6){
          let lastValue = this.form.getFieldValue('riskPoint' + this.riskPointNumber)
          if(lastValue){
            this.riskPointNumber++;
          } else {
            this.$message.info("风险点" + this.riskPointNumber + "不能为空")
          }
        } else {
          this.$message.info("最多只能增加6个风险点")
        }
      },

      handleDelRiskPoint(){
        if(this.riskPointNumber >1) {
          if(this.riskPointNumber === 6){
            this.form.setFieldsValue({riskPoint6:null, solution6: null})
          }
          if(this.riskPointNumber === 5){
            this.form.setFieldsValue({riskPoint5:null, solution5: null})
            this.model.riskPoint5  = null
            this.model.solution5 = null
          }
          if(this.riskPointNumber === 4){
            this.form.setFieldsValue({riskPoint4:null, solution4: null})
            this.model.riskPoint4  = null
            this.model.solution4 = null
          }
          if(this.riskPointNumber === 3){
            this.form.setFieldsValue({riskPoint3:null, solution3: null})
            this.model.riskPoint3  = null
            this.model.solution3 = null
          }
          if(this.riskPointNumber === 2){
            this.form.setFieldsValue({riskPoint2:null, solution2: null})
            this.model.riskPoint2  = null
            this.model.solution2 = null
          }
          this.riskPointNumber--;
        } else {
          this.$message.info("风险点1不能删除")
        }
      },

      // 文件变化
      handleFileChange(filePath){
        // 编辑状态下变化，存在单据id
        let id = this.model.id
        if(id){
          postAction(this.url.updateFilePath, {id: id, filePath: filePath}).then(res =>{
            if(res.success){

            } else {
              this.$message.warn("附件更新时出现错误:" + res.message)
            }
          })
        }
      },

      submitForm () {
        const that = this;
        //let file = this.form.getFieldValue("file")

        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = Object.assign(this.model, values);

            this.trimFormData(formData);

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },

      trimFormData(formData){
        formData.auditRemark = formData.auditRemark ? formData.auditRemark.trim() : '';
      },

      popupCallback(row){
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'projId','surveyResult', 'riskPoint1','solution1','riskPoint2','solution2',
            'riskPoint3','solution3','riskPoint4','solution4','riskPoint5','solution5','riskPoint6','solution6',
            'file','auditRemark'))
        })
      },
    }
  }
</script>

<style>
  /**控制主体颜色*/
  .draw_atooltip .ant-tooltip-inner {
    color: #ccc !important;
    background-color: #fff !important;
    min-width: 500px !important;
  }
  /*控制三角形颜色*/
  .draw_atooltip .ant-tooltip-arrow::before {
    background-color: #fff;
  }
</style>